import { render, staticRenderFns, recyclableRender, components } from "./vinSearch.vue?vue&type=template&id=73e8f2e0&"
var renderjs
import script from "./vinSearch.vue?vue&type=script&lang=js&"
export * from "./vinSearch.vue?vue&type=script&lang=js&"
import style0 from "./vinSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/item/vinSearch.vue"
export default component.exports